import { createSelector } from 'reselect'

const getNginxSettingsOptions: SelectOptionsSelector = (state) =>
  state.nginxSettings.nginxSettingsForOptions.map((item) => ({
    id: item.id,
    name: item.name
  })) || ([] as SelectOption[])

export const nginxSettingsSelectOptionsSelector: SelectOptionsSelector = createSelector(getNginxSettingsOptions, (options) => options)
